// extracted by mini-css-extract-plugin
module.exports = {"company":"_1cPX0jo5bYATtAAs_HIDpG","paragraph":"u84zJgce_hhmihfYbDy_Q","comapniesLogos":"vG41iWEPETM394HLTetT0","logo":"_2GGHNOKlxyzyaG3m63jAkG","row":"_2VLrJxqoMznj7Ctibe5IjY"};